import { DonchianChannel as defaultOptions } from "./defaultOptionsForComputation";
import { isDefined } from "../utils";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { highPeriod, lowPeriod } = options;

    const results = [];

    for (let i = 0; i < data.length; i++) {
      if (i < Math.max(highPeriod, lowPeriod) - 1) {
        results.push(undefined);
        continue;
      }

      // Calculate highest high over highPeriod
      let high = -Infinity;
      for (let j = 0; j < highPeriod; j++) {
        if (isDefined(data[i - j].high)) {
          high = Math.max(high, data[i - j].high);
        }
      }

      // Calculate lowest low over lowPeriod
      let low = Infinity;
      for (let j = 0; j < lowPeriod; j++) {
        if (isDefined(data[i - j].low)) {
          low = Math.min(low, data[i - j].low);
        }
      }

      // Calculate median
      const middle = (high + low) / 2;

      results.push({
        top: high,
        middle: middle,
        bottom: low,
      });
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return Math.max(options.highPeriod, options.lowPeriod) - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
